import { Button, Flex, Icon, List, ListItem, Text } from '@/ui';
import { PlanBadge } from '../../../components/PlanBadge';

type Props = {
  name: string;
  price: string;
  period: string;
  seatsLabel: string;
  features: string[];
  ctaLabel: string;
  badgeLabel?: string;
  /** Pink border + solid CTA, marking the plan we steer people toward. */
  isRecommended?: boolean;
  onSelect: () => void;
};

// A buyable plan, rendered inline in the settings panel rather than in the
// compare-plans modal. Deliberately separate from UpgradeModal's OrgPricingCard:
// that card carries the modal's register/contact actions and its own accent,
// while this one only ever starts a checkout.
export const PlanOptionCard = ({
  name,
  price,
  period,
  seatsLabel,
  features,
  ctaLabel,
  badgeLabel,
  isRecommended = false,
  onSelect,
}: Props) => (
  <Flex
    borderColor={isRecommended ? 'brand.500' : 'gray.200'}
    borderRadius="ah-xl"
    borderWidth="1px"
    direction="column"
    gap="4"
    p="6"
  >
    <Flex align="center" gap="3" justify="space-between">
      <Text fontSize="2xl" fontWeight="medium" lineHeight="short">
        {name}
      </Text>
      {badgeLabel && <PlanBadge>{badgeLabel}</PlanBadge>}
    </Flex>

    <Flex direction="column" gap="1">
      <Flex align="baseline" gap="0.5">
        <Text fontSize="2xl" fontWeight="bold" lineHeight="short">
          {price}
        </Text>
        <Text color="customgray.middark" fontSize="sm">
          {period}
        </Text>
      </Flex>
      <Text color="customgray.mid" fontSize="sm">
        {seatsLabel}
      </Text>
    </Flex>

    <List display="flex" flexDirection="column" gap="2">
      {features.map((feature) => (
        <ListItem alignItems="center" display="flex" gap="2.5" key={feature}>
          <Icon color="brand.500" flexShrink={0} icon="Checkmark" size="4" />
          <Text fontSize="sm">{feature}</Text>
        </ListItem>
      ))}
    </List>

    <Button
      mt="auto"
      variant={isRecommended ? 'solid' : 'secondary'}
      onClick={onSelect}
    >
      {ctaLabel}
    </Button>
  </Flex>
);
